import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services';
import { checkTranslation, imageAddress, translate } from '../../utils/useful';
import FixedView from '../FixedView'
import IntractionActionsList from '../IntractionActionsList';
import Modal from '../Modal';


export default class SelectApplet extends Component {
    state = {
        fixed: true,
        list: [],
        currentApplet: '',
        currentAppletName: 'All',
    }

    componentDidMount() {
        if (this.props.currentAppletName) {
            let currentAppletName = this.props.currentAppletName
            this.setState({ currentAppletName })
        }
        if (this.props.currentApplet) {
            let currentApplet = this.props.currentApplet
            this.setState({ currentApplet })
        }
        let data = {}
        data.features = this.props.type
        let list = this.state.list
        HttpServices.request('getMyFramesByType', data, (fetchResult, fetchError) => {

            if (fetchError) {
                return
            }
            fetchResult.info.map((element, index) => {
                if (element.applet.default) {
                    element.applet.name = element.appletHub.fullname
                }
            })
            list = fetchResult.info
            list.unshift({ name: 'All' })
            this.setState({ list, })
        })
        // this.appletView.addEventListener('click', (e) => {
        //     let inside = e.target.closest('')

        // })
    }

    componentDidUpdate(prevProps) {
        if ((this.props.currentAppletName && (this.props.currentAppletName != prevProps.currentAppletName)) || (this.props.currentApplet && (this.props.currentApplet != prevProps.currentApplet))) {
            this.setState({ currentApplet: this.props.currentApplet, currentAppletName: this.props.currentAppletName })
        }
    }

    openAppletView = () => {
        // this.appletView.showView();
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {

            if (!this.state.fixed) {
                this.appletView.showView()
            }
            // else {
            //     this.appletView.hideView()

            // }
        })
    };

    onHide = () => {

        let view = this.state.fixed
        this.setState({ fixed: false }, () => {
        })
    };

    changeApplet = (prop) => {

        let currentApplet = this.state.currentApplet
        let currentAppletName = this.state.currentAppletName
        if (!prop?.applet) {
            currentApplet = ''
            currentAppletName = prop.name
        }
        else {
            currentApplet = prop.applet._id
            currentAppletName = prop.applet.name

        }
        this.setState({ currentApplet, currentAppletName }, () => {
            this.props.setData('currentApplet', currentApplet, () => {
                this.props.setData('currentAppletName', currentAppletName, () => {
                    if (this.props.setDataMain) {

                        this.props.setDataMain('appletSelected', true, 'DrivePortal', () => {
                            if (this.props.type == 'Drive') {
                                // this.props.changeFrame(this.props.driveSections[0])
                            }
                        })
                    }
                    if (this.props.functionHandler) {
                        this.props.functionHandler()
                    }
                })
            })
            return currentApplet
        })
    }

    onHide = () => {
        if (this.props.onHide) {
            this.props.onHide()
        }
    }

    render() {
        let { list } = this.state
        return (
            <div>
                <button onClick={() => this.appletView.showView()} ref={el => this.currentNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
                        <div className='flexcc mrd-1'>
                            <img className={this.props.invert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: this.props.color ?? '#fff', textWrap: 'nowrap' }}>{checkTranslation(this.state.currentAppletName)}</p>
                    </div>
                </button>
                {/* <button className='w-100 ' onClick={() => this.openAppletView()}>
                    <div className='flexcb w-100' style={{ borderBottom: '2px solid #fff' }}>
                        <p className='white font-size-16 weight-400'>{checkTranslation(this.state.currentAppletName)}</p>
                        <img className={' ' + (this.state.fixed == true ? " transition-1 rotate-180 " : "  transition-1 ")} src='/assets/icons/arrow-up-white.svg' />
                    </div>
                </button> */}
                <FixedView ref={el => this.appletView = el} nodeRef={this.currentNode} zIndex={10} topOffset={5} xOffset={-10} width={260}>
                    <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                        <div className='white-bg' style={{}}>
                            {Array.isArray(list) && list.map((prop, index) => {
                                let name = prop?.applet?.name ? prop?.applet?.name : prop.name
                                return (
                                    <IntractionActionsList language={this.props.language} onClick={() => { this.changeApplet(prop); this.appletView.hideView() }} data={{ title: prop?.applet?.name ? checkTranslation(prop?.applet?.name) : prop.name, icon: name ? '/assets/icons/messenger/infinity.svg' : imageAddress(prop.applet?.image, "applet") }} />
                                )
                            })}
                        </div>
                    </div>
                    {/* <div className='white-bg px-2 br-10 select-applet-border2 w-100'>
                        {list?.map((prop, index) => {
                            let name = prop?.applet?.name ? prop?.applet?.name : prop.name
                            return (
                                <div className='bb-gray py-2'>
                                    <button className='flexc py-2 px-2 w-100 hover-gray2 br-5' onClick={() => this.changeApplet(prop)}>
                                        <div className='mrd-2'>
                                            {name == 'All' ? (
                                                <img className='br-50' width={30} height={30} src='/assets/icons/messenger/infinity.svg' />

                                            ) : (
                                                <img className='br-50' width={30} height={30} src={imageAddress(prop.applet?.image, "applet")} />

                                            )}
                                        </div>
                                        <p>{prop?.applet?.name ? checkTranslation(prop?.applet?.name) : prop.name}</p>
                                    </button>
                                </div>
                            )
                        })}
                    </div> */}
                </FixedView>
                <Modal maxWidth={300} className="" ref={el => this.appletViewModal = el} onHide={this.onHide}>
                    <div className='bg-white br-10 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                        <p className='font-size-14 main-c2 weight-500 px-3 pt-3 pb-2' style={{}}>{translate('Select applet')}</p>
                        <div className='white-bg px-2 pb-2' style={{}}>
                            {Array.isArray(list) && list.map((prop, index) => {
                                let name = prop?.applet?.name ? prop?.applet?.name : prop.name
                                if (prop._id != 'all') {
                                    return (
                                        <IntractionActionsList language={this.props.language} onClick={() => { this.changeApplet(prop); this.appletViewModal.close() }} data={{ title: prop?.applet?.name ? checkTranslation(prop?.applet?.name) : prop.name, icon: name ? '/assets/icons/messenger/infinity.svg' : imageAddress(prop.applet?.image, "applet") }} />
                                    )
                                }
                            })}
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}
